import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button } from 'react-bootstrap';

interface CalculatorFormProps {
    onCalculate: (result: number | string) => void;
}

const CalculatorForm: React.FC<CalculatorFormProps> = ({ onCalculate }) => {
    const [num1, setNum1] = useState<number | ''>('');
    const [num2, setNum2] = useState<number | ''>('');
    const [operator, setOperator] = useState<string>('+');
    const [error, setError] = useState<string | null>(null);

    // 記号を文字列にマッピング
    const operatorMap: { [key: string]: string } = {
        '+': 'add',
        '-': 'subtract',
        '*': 'multiply',
        '/': 'divide'
    };

    const handleCalculate = async () => {
        setError(null); // 計算するたびに、一度エラーは初期化
        try {
            const response = await axios.get('../api/calculate', {
                params: {
                    num1,
                    num2,
                    operator: operatorMap[operator]  // マッピングされた演算子に置き換える
                }
            });
            onCalculate(response.data.result);
        } catch (err) {
            // APIで何かエラーが発生した場合
            setError("計算エラーが発生しました");
        }
    };

    return (
        <Form>
            <Form.Group controlId="num1">
                <Form.Label>数値1</Form.Label>
                <Form.Control
                    type="number"
                    value={num1}
                    onChange={(e) => setNum1(e.target.value === '' ? '' : parseFloat(e.target.value))}
                />
            </Form.Group>

            <Form.Group controlId="operator" className="mt-3">
                <Form.Label>演算子</Form.Label>
                <Form.Control
                    as="select"
                    value={operator}
                    onChange={(e) => setOperator(e.target.value)}
                >
                    <option value="+">+</option>
                    <option value="-">-</option>
                    <option value="*">*</option>
                    <option value="/">/</option>
                </Form.Control>
            </Form.Group>

            <Form.Group controlId="num2" className="mt-3">
                <Form.Label>数値2</Form.Label>
                <Form.Control
                    type="number"
                    value={num2}
                    onChange={(e) => setNum2(e.target.value === '' ? '' : parseFloat(e.target.value))}
                />
            </Form.Group>

            <Button variant="primary" className="mt-4" onClick={handleCalculate}>
                計算
            </Button>
            {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
        </Form>
    );
};

export default CalculatorForm;
